export default [
    {
        img: 'dl',
        header: 'Демонлист',
        route: '/dl'
    },
    {
        img: 'cl',
        header: 'Челенджлист',
        route: '/cl'
    },
    {
        img: 'pl',
        header: 'Платформерлист',
        route: '/pl'
    },
];